module.exports = __webpack_public_path__ + "img/RisingStarsArtsFestival_06-29-2014_jr_MG_9366_SN.0cc8d114.webp";